<template>
    <div
        class="rounded-[12.8px] border border-[#FDE68A] bg-[#FFFBEB] px-4 py-[22px]"
    >
        <div class="flex items-start justify-between gap-4">
            <div class="flex min-w-0 items-start gap-2.5">
                <div class="pt-[2px]">
                    <slot name="icon">
                        <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                d="M10.0834 8.35313L6.37087 1.85625C6.28992 1.71342 6.17253 1.59461 6.03068 1.51195C5.88882 1.42929 5.72758 1.38574 5.5634 1.38574C5.39922 1.38574 5.23798 1.42929 5.09613 1.51195C4.95427 1.59461 4.83688 1.71342 4.75593 1.85625L1.04343 8.35313C0.961612 8.49483 0.918707 8.65565 0.91907 8.81928C0.919432 8.98292 0.963048 9.14354 1.0455 9.28488C1.12795 9.42623 1.2463 9.54326 1.38856 9.62412C1.53081 9.70498 1.69192 9.74679 1.85554 9.74532H9.28054C9.44338 9.74515 9.60331 9.70214 9.74427 9.62062C9.88523 9.53909 10.0023 9.42191 10.0836 9.28084C10.165 9.13978 10.2078 8.97979 10.2077 8.81695C10.2077 8.65411 10.1648 8.49415 10.0834 8.35313Z"
                                stroke="#744210"
                                stroke-width="1.03125"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M5.56836 4.17676V6.03301"
                                stroke="#744210"
                                stroke-width="1.03125"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M5.56836 7.88916H5.57379"
                                stroke="#744210"
                                stroke-width="1.03125"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </slot>
                </div>
                <div class="min-w-0">
                    <p
                        class="text-[14px] font-medium leading-[142%] text-[#744210]"
                    >
                        {{ title }}
                    </p>
                    <p
                        v-if="description"
                        class="mt-1 text-[12.25px] font-normal leading-[142%] text-[#744210]"
                    >
                        {{ description }}
                    </p>
                </div>
            </div>

            <slot name="actions"></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    title: string;
    description?: string;
}>();
</script>
